import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {ConstanteService} from '../../../_services/constante.service';
import {AdmsbConstanteCacheService} from './admsb-constante-cache.service';

@Component({
  selector: 'app-admsb-titular',
  templateUrl: './admsb-titular.component.html',
  styleUrls: ['./admsb-titular.component.scss'],
  providers: [{provide: ConstanteService, useClass: AdmsbConstanteCacheService}],
})
export class AdmsbTitularComponent implements OnInit {

  /** Identificador de la pasarela del titular  */
  idTitular: string;

  /** Identificador del tercero titular de la pasarela */
  idTercero: string;

  /** Nombres de los métodos de pasarela habilitados */
  metodos = '';

  /** Identificador de la solicitud de unidad de crédito - unidad productiva */
  idSolicitudUCUnidadProductiva: string;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
  ) {
  }

  ngOnInit(): void {
    this.idTitular = this.route.snapshot.paramMap.get('id');
    this.idTercero = this.route.snapshot.queryParamMap.get('idTercero');
    this.metodos = this.route.snapshot.queryParamMap.get('metodos') ?? '';
    this.idSolicitudUCUnidadProductiva = this.route.snapshot.queryParamMap.get('idSolicitudUCUnidadProductiva');
  }

  regresar(): void {
    this.location.back();
  }

}
